<template>
    <div class="templete_box">
        <div class="crumbsNav no_print clearfix">
            <div :class="['navSon',tab==1?'navSonChecked':'']" @click="changeTab(1)">
                云链同步
            </div>
            <div :class="['navSon',tab==2?'navSonChecked':'']" @click="changeTab(2)">
                定向同步
            </div>
        </div>
        <cloudManage v-if="tab == 1"></cloudManage>
        <cloudManageDirection v-if="tab == 2"></cloudManageDirection>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                tab : 1
            }
        },
        created(){
        },
        methods:{
            changeTab(tab){
                //this.tab=tab;
                this.$set(this,"tab",tab);
            }
        }
    }
</script>
<style scoped>

</style>